<div class="article-preview row" (click)="openArticle()">


  <div class="col-12 col-sm-12 col-md-4 image-column-wrapper">
    <div class="article-image" [ngStyle]="getArticleBg()"></div>

  </div>

  <div class="col-12 col-sm-12 col-md-8 text-column-wrapper">
    <div class="preview-text-content">
      <h4 class="ui header">{{ article.title}}</h4>
      <div class="labels">
        <div class="ui label">
          <i class="ui icon calendar"></i>
          {{ article.updatedAt | localizedDate}}
          <!--{{ article.createdAt | localizedDate:'mediumDate'}}-->
        </div>
        <div class="ui label topic-label" [ngClass]="article.topic" *ngIf="article.topic">
          {{'ARTICLE.TOPICS.' + article.topic | translate}}
        </div>
      </div>
      <p class="article-summary">
        {{article.summary}}
      </p>
    </div>
  </div>

</div>
